// utils/theme.js
import Vue from "vue";

export const themeState = Vue.observable({
  theme: localStorage.getItem("THEME") || "light",
});

export function setTheme(theme) {
  themeState.theme = theme;
  document.documentElement.setAttribute("data-theme", theme);
  localStorage.setItem("THEME", theme);
}
